const messages: Record<string, string> = {
    'menu.dashboard': '仪表盘',
    'menu.vehicles': '车辆',
    'menu.stations': '场站',
    'menu.stops': '停靠点',
    'menu.dispatch': '调度',
    'menu.monitor': '监控',
    'menu.logs': '日志',
    'menu.settings': '设置',
};

export default messages;
